import React from 'react';
import { Box, Container, Link } from '@mui/material';
import { SignInForm } from './SignInForm';

export default function SignInPage() {
    
    const authStrings = {
        signInHeader: "Sign In",
        signInSubtitle: "Continue to CandidateTools",
        emailLabel: "Email or phone", 
        passwordLabel: "Enter your password",
        forgotPassword: "Forgot password?",
        nextButton: "Next", // Google prefers "Next" over "Sign In"
        switchToSignUp: "Create account",
    };

    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            minHeight: '100vh', 
            bgcolor: '#f0f2f5', // Standard light grey background
        }}>
            <Container component="main" maxWidth="lg" sx={{ 
                flexGrow: 1, 
                display: 'flex', 
                flexDirection: 'column', 
                justifyContent: 'center', 
                alignItems: 'center',
                py: 4 
            }}>
                <SignInForm strings={authStrings} />

                {/* Footer */}
                <Box sx={{ display: 'flex', gap: 3, mt: 3, opacity: 0.7 }}>
                    <Link href="/help" variant="body2" color="text.secondary" sx={{ textDecoration: 'none', fontSize: '0.8rem' }}>Help</Link>
                    <Link href="/privacy" variant="body2" color="text.secondary" sx={{ textDecoration: 'none', fontSize: '0.8rem' }}>Privacy</Link>
                    <Link href="/terms" variant="body2" color="text.secondary" sx={{ textDecoration: 'none', fontSize: '0.8rem' }}>Terms</Link>
                </Box>
            </Container>
        </Box>
    );
}